var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 21,
    viewBox: "0 0 109 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0918,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9864,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.8809,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.7754,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.67,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5655,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.46,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.355,
    cy: 2.64555,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0918,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9864,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.8809,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.7754,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.67,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5645,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.46,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.355,
    cy: 18.5402,
    r: 2.44731,
    fill: "#007AAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrDots);
export default __webpack_public_path__ + "static/media/hrDots.7370ca8a7978a5b4f7b6eb55c294acd2.svg";
export { ForwardRef as ReactComponent };